import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';
import { GetBaseBusinessSuccessResponseInfo } from '@/coreInfrastructureModule/axios/generated/baseBusinessManage';

/**
 * 編集ページの集計の子取引情報取得UseCase
 */
export class BulkGetBaseBusinessUseCase {
  private repository: IBaseBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessRepository) {
    this.repository = repository;
  }

  // eslint-disable-next-line jsdoc/require-jsdoc
  public async execute(
    sortType: SortType,
    sortTarget: string,
    limit: number,
    offset: number,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<GetBaseBusinessSuccessResponseInfo, IError>>;

  // eslint-disable-next-line jsdoc/require-jsdoc
  public async execute<T>(
    sortType: SortType,
    sortTarget: string,
    limit: number,
    offset: number,
    filterItems: FilterContentItem[],
    adapter: (response: GetBaseBusinessSuccessResponseInfo) => T
  ): Promise<INetworkResult<T, IError>>;

  /**
   * 集計に紐づく子取引情報の取得
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param filterItems - フィルターの一覧
   * @param adapter - レスポンスをUIクラスに変更するアダプタ(指定しない場合レスポンス型がそのまま返る)
   */
  public async execute<T>(
    sortType: SortType,
    sortTarget: string,
    limit: number,
    offset: number,
    filterItems: FilterContentItem[],
    adapter?: (response: GetBaseBusinessSuccessResponseInfo) => T
  ): Promise<INetworkResult<GetBaseBusinessSuccessResponseInfo | T, IError>> {
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    try {
      const response = await this.repository.getBaseBusiness(sortType, limit, offset, filterItem, sortTarget, undefined);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: adapter ? adapter(response.status.data.result) : response.status.data.result,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
